<script>
import NavBar from '@components/nav-bar.vue'
import UserDropdown from '@components/user-dropdown.vue'
import { authComputed } from '@state/helpers'
import GlobalError from '@components/global-error.vue'

export default {
  components: { NavBar, UserDropdown, GlobalError },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <div :class="$style.page">
    <GlobalError />
    <div :class="$style.container">
      <header v-if="loggedIn" id="header" :class="$style.header">
        <BaseLink name="home">
          <img
            :class="$style.logo"
            src="@assets/images/logo.png"
            alt="Kooi Security"
          />
        </BaseLink>
        <NavBar />
        <UserDropdown />
      </header>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.page {
  position: relative;
  padding-bottom: 140px;

  @media (min-width: $breakpoint-lg) {
    padding-bottom: 0;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 25px 0;

  .logo {
    height: 41px;
  }
}

.container {
  width: 100%;
  max-width: $container-width;
  margin: 0 auto;
}
</style>
